import { lazy } from 'react';
/** Открывает форму исполнителя */
export const ExecutorFormPageAsync = lazy(() => import('./ExecutorForm/ExecutorFormPage'));